import Pathurl from "../Class/Pathurl.json";



/// Add By POOM : 2023-07-20 
/// Edit By POOM : 2023-11-02
/// ปรับเพิ่ม actmenu service_list สำหรับ เช็ค service ของ company
/// ใช้สำหรับ เช็คว่า มีสิทธิ์ในการใช้งาน หรือไม่  
/// actmenu             ==> หมายถึงกำลังเช็คสิทธิ์ในหน้าไหน   'main' , 'master' , 'report'  
/// permissionmame      ==> จะรับมาเป็น Array   ตัวอย่างที่ส่งเข้ามา 
///                         เช่น { "projects_view" , "projects_add" , "projects_edit"}   
/// PermissionNotFull   ==> true , false  ใช้ในกรณีที่  ส่ง permissionmame เข้ามาเช็คมากกว่า 1 ตัว  
///                         แล้วต้องการเช็คว่า  สิทธิที่ส่งมา  ขอแค่มี สิทธิ 1 สิทธิ ก็พอ หรือ ต้องมีครบทุกสิทธิ 
///                     ==> false = ต้องมีครบทุกสิทธิ
///                     ==> true  = ขอแค่มี 1 สิทธิ ก็พอ
/// gotonoperrmission   ==> true , false ถ้ากรณีที่ เช็คแล้วไม่มีสิทธิ จะให้ทำยังไงต่อ
///                     ==> true = ให้เด้งไปหน้า ไม่มีสิทธิการใช้งาน
///                     ==> false = ให้ return false กลับไป เพื่อให้หน้าที่ส่งเข้ามาไปใช้งานต่อ ในกรณีที่อยาก แสดงหรือปิดปุ่มการบันทึก
export const CP_CheckPermission = (actmenu , permissionmame , permissionNotFull , gotonoperrmission) => {
    
    let _return = false;
    try
    {
        let ls_value = "";
        if (actmenu === "main"){
            ls_value = localStorage.getItem("per_menu_main");
        }
        else if (actmenu === "master"){
            ls_value = localStorage.getItem("per_menu_master");
        }
        else if (actmenu === "service_list"){
            ls_value = localStorage.getItem("service_list");
        }
        else{
            ls_value = localStorage.getItem("per_menu_report");
        }

        if (ls_value === null || ls_value === "")
        {
            // เจอ null เราจะทำการ Return false ทันที  
            _return = false;
        }
        else
        {
            let inum = 0;
            let Arr_Priv_List = ls_value.split(',') 
            if (Arr_Priv_List.length > 0)
            {
                permissionmame.forEach(en => {
                    for (let i = 0; i < Arr_Priv_List.length; i++)
                    {
                        if (en.toLowerCase() === Arr_Priv_List[i].toLowerCase())
                        {
                            inum++;
                            break;
                        }
                    }
                });
            }
            
            if (!permissionNotFull)
            {// หมายถึง ให้มีครบทุกสิทธิ 
                if (inum !== permissionmame.length)
                { // สิทธิ ไม่ครบทุกอัน
                    _return = false;
                }
                else
                { // สิทธิ ครบทุกสิทธิ
                    _return = true;
                }
            }
            else
            {// หมายถึง มีอย่างน้อย 1 สิทธิ ก็พอแล้ว
                if (inum === 0)
                {// สิทธิไม่มีเลย
                    _return = false;
                }
                else
                {
                    _return = true;
                }
            }

        }
        
        if (_return === false && gotonoperrmission) 
        {
            window.location.replace("../" + Pathurl.no_permission);
        }

    }
    catch
    {   ///เจอ catch ให้เด้งไปหน้า No_Permission ทันที
        window.location.replace("../" + Pathurl.no_permission);
    }

    return _return;
  };
  